import { render, staticRenderFns } from "./objDialog.vue?vue&type=template&id=2bbd39eb&scoped=true"
import script from "./objDialog.vue?vue&type=script&lang=js"
export * from "./objDialog.vue?vue&type=script&lang=js"
import style0 from "./objDialog.vue?vue&type=style&index=0&id=2bbd39eb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbd39eb",
  null
  
)

export default component.exports